import AppConfig from '@/app.config.js'
import router from '@/router.js'
import api from "@/services/apiService"

import firebase from 'firebase/app'
import 'firebase/auth'

class AuthService {

  saveLogin(loginResult) {
    return new Promise(async (resolve) => {
      await localStorage.setItem(AppConfig.auth.isLoggedIn, 'true');
      await localStorage.setItem(AppConfig.auth.accessToken, loginResult.accessToken);
      await localStorage.setItem(AppConfig.auth.userRole, loginResult.role);
      resolve(true);
    });
  }

  isLoggedIn() {
    return localStorage.getItem(AppConfig.auth.isLoggedIn) === 'true';
  }

  async logout() {
    await localStorage.removeItem(AppConfig.auth.isLoggedIn)
    await localStorage.removeItem(AppConfig.auth.accessToken)
    await localStorage.removeItem(AppConfig.auth.userRole)
    await firebase.auth().signOut()

    //location.reload(true)
    router.push({name:'auth-login'})
  }

  getProfile() {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          firebase
          .auth()
          .currentUser
          .getIdToken(true)
          .then(async (idToken)=>{
            await localStorage.setItem(AppConfig.auth.accessToken, idToken)
            resolve({
              fullname: user.displayName,
              username: user.email,
              role: 'Admin',
              img: user.photoURL
            })
          })
        } else {
          reject(null)
        }
      });
    });
  }

  updateProfile(data) {
    return new Promise((resolve, reject) => {
      api.post(AppConfig.api.url + 'profile', data)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

  changePassword(data) {
    return new Promise((resolve, reject) => {
      api.post(AppConfig.api.url + 'password', data)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

}

export default new AuthService();
